/**
 * The cue: until the first scroll, a dot runs down a hairline at the bottom;
 * if nothing happens for a while, it brightens.
 */

/* =====================================================================
   TUNING
   ===================================================================== */
const CUE_IN = 1.2 /* s after the globe has settled on the hero before the cue shows */
const CUE_DELAY = 5 /* s of nothing before it brightens */
/* ===================================================================== */

/** How the cue looks `idle` seconds after the globe settled. */
export function cueState(idle: number, scrolled: boolean) {
  return {
    on: !scrolled && idle > CUE_IN,
    loud: !scrolled && idle > CUE_IN + CUE_DELAY,
  }
}

export function createCue(el: HTMLElement) {
  return {
    update(idle: number, scrolled: boolean) {
      const state = cueState(idle, scrolled)
      el.classList.toggle('on', state.on)
      el.classList.toggle('loud', state.loud)
    },
  }
}

export type Cue = ReturnType<typeof createCue>
